/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as VerifyTokenRouteImport } from './routes/verify.$token'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthEntryRouteImport } from './routes/auth/entry'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as ProtectedWarehouseRouteImport } from './routes/_protected/warehouse'
import { Route as ProtectedSpecializedDonorsRouteImport } from './routes/_protected/specialized-donors'
import { Route as ProtectedSettingsRouteImport } from './routes/_protected/settings'
import { Route as ProtectedReportsRouteImport } from './routes/_protected/reports'
import { Route as ProtectedRecipientsRouteImport } from './routes/_protected/recipients'
import { Route as ProtectedProcessingRouteImport } from './routes/_protected/processing'
import { Route as ProtectedLaboratoryRouteImport } from './routes/_protected/laboratory'
import { Route as ProtectedLabarotaroyResearchRouteImport } from './routes/_protected/labarotaroyResearch'
import { Route as ProtectedHomeRouteImport } from './routes/_protected/home'
import { Route as ProtectedExpeditionRouteImport } from './routes/_protected/expedition'
import { Route as ProtectedDonorsRouteImport } from './routes/_protected/donors'
import { Route as ProtectedDonationsRouteImport } from './routes/_protected/donations'
import { Route as ProtectedDictionaryRouteImport } from './routes/_protected/dictionary'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedContractsRouteImport } from './routes/_protected/contracts'
import { Route as ProtectedWarehouseIndexRouteImport } from './routes/_protected/warehouse/index'
import { Route as ProtectedLaboratoryIndexRouteImport } from './routes/_protected/laboratory/index'
import { Route as ProtectedLabarotaroyResearchIndexRouteImport } from './routes/_protected/labarotaroyResearch/index'
import { Route as ProtectedDonorsIndexRouteImport } from './routes/_protected/donors/index'
import { Route as ProtectedContractsIndexRouteImport } from './routes/_protected/contracts/index'
import { Route as ProtectedWarehouseStockRouteImport } from './routes/_protected/warehouse/stock'
import { Route as ProtectedWarehouseIssuanceRouteImport } from './routes/_protected/warehouse/issuance'
import { Route as ProtectedWarehouseContainersRouteImport } from './routes/_protected/warehouse/containers'
import { Route as ProtectedWarehouseApplicationsRouteImport } from './routes/_protected/warehouse/applications'
import { Route as ProtectedLaboratoryOrderIdRouteImport } from './routes/_protected/laboratory/$orderId'
import { Route as ProtectedLabarotaroyResearchVisitIdRouteImport } from './routes/_protected/labarotaroyResearch/$visitId'
import { Route as ProtectedExpeditionStorageRouteImport } from './routes/_protected/expedition/storage'
import { Route as ProtectedExpeditionSecondaryProcessingRouteImport } from './routes/_protected/expedition/secondary-processing'
import { Route as ProtectedExpeditionQualityControlRouteImport } from './routes/_protected/expedition/quality-control'
import { Route as ProtectedExpeditionFractionationRouteImport } from './routes/_protected/expedition/fractionation'
import { Route as ProtectedExpeditionCryoprecipitateRouteImport } from './routes/_protected/expedition/cryoprecipitate'
import { Route as ProtectedDonorsVisitIdRouteImport } from './routes/_protected/donors/$visitId'
import { Route as ProtectedDictionaryAnalysisRouteImport } from './routes/_protected/dictionary/analysis'
import { Route as ProtectedContractsTypeRouteImport } from './routes/_protected/contracts/$type'
import { Route as ProtectedRecipientsTransfusionsIndexRouteImport } from './routes/_protected/recipients/transfusions/index'
import { Route as ProtectedRecipientsListIndexRouteImport } from './routes/_protected/recipients/list/index'
import { Route as ProtectedRecipientsBloodConsumptionIndexRouteImport } from './routes/_protected/recipients/blood-consumption/index'
import { Route as ProtectedLabarotaroyResearchVisitIdIndexRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.index'
import { Route as ProtectedDonorsVisitIdIndexRouteImport } from './routes/_protected/donors/$visitId.index'
import { Route as ProtectedDictionaryOrganizationsIndexRouteImport } from './routes/_protected/dictionary/organizations/index'
import { Route as ProtectedRecipientsTransfusionsNewRouteImport } from './routes/_protected/recipients/transfusions/new'
import { Route as ProtectedRecipientsTransfusionsTransfusionIdRouteImport } from './routes/_protected/recipients/transfusions/$transfusionId'
import { Route as ProtectedRecipientsBloodConsumptionNewRouteImport } from './routes/_protected/recipients/blood-consumption/new'
import { Route as ProtectedRecipientsBloodConsumptionProtocolIdRouteImport } from './routes/_protected/recipients/blood-consumption/$protocolId'
import { Route as ProtectedLaboratoryNotificationsNewRouteImport } from './routes/_protected/laboratory/notifications.new'
import { Route as ProtectedLaboratoryNotificationsNotificationIdRouteImport } from './routes/_protected/laboratory/notifications.$notificationId'
import { Route as ProtectedLabarotaroyResearchVisitIdScreeningRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.screening'
import { Route as ProtectedLabarotaroyResearchVisitIdMedicalSurveyRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.medical-survey'
import { Route as ProtectedLabarotaroyResearchVisitIdMedicalHistoryRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.medical-history'
import { Route as ProtectedLabarotaroyResearchVisitIdDonationRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.donation'
import { Route as ProtectedLabarotaroyResearchVisitIdDeferredRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.deferred'
import { Route as ProtectedLabarotaroyResearchVisitIdBloodCollectionRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.blood-collection'
import { Route as ProtectedDonorsVisitIdScreeningRouteImport } from './routes/_protected/donors/$visitId.screening'
import { Route as ProtectedDonorsVisitIdMedicalSurveyRouteImport } from './routes/_protected/donors/$visitId.medical-survey'
import { Route as ProtectedDonorsVisitIdMedicalHistoryRouteImport } from './routes/_protected/donors/$visitId.medical-history'
import { Route as ProtectedDonorsVisitIdDonationRouteImport } from './routes/_protected/donors/$visitId.donation'
import { Route as ProtectedDonorsVisitIdDocumentsRouteImport } from './routes/_protected/donors/$visitId.documents'
import { Route as ProtectedDonorsVisitIdDeferredRouteImport } from './routes/_protected/donors/$visitId.deferred'
import { Route as ProtectedDonorsVisitIdBloodCollectionRouteImport } from './routes/_protected/donors/$visitId.blood-collection'
import { Route as ProtectedDictionaryOrganizationsNewRouteImport } from './routes/_protected/dictionary/organizations/new'
import { Route as ProtectedDictionaryOrganizationsInnRouteImport } from './routes/_protected/dictionary/organizations/$inn'
import { Route as ProtectedLabarotaroyResearchVisitIdLabResearchIndexRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.lab-research.index'
import { Route as ProtectedDonorsVisitIdLabResearchIndexRouteImport } from './routes/_protected/donors/$visitId.lab-research.index'
import { Route as ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRouteImport } from './routes/_protected/labarotaroyResearch/$visitId.lab-research.$researchId'
import { Route as ProtectedDonorsVisitIdLabResearchResearchIdRouteImport } from './routes/_protected/donors/$visitId.lab-research.$researchId'

const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyTokenRoute = VerifyTokenRouteImport.update({
  id: '/verify/$token',
  path: '/verify/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEntryRoute = AuthEntryRouteImport.update({
  id: '/entry',
  path: '/entry',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedWarehouseRoute = ProtectedWarehouseRouteImport.update({
  id: '/warehouse',
  path: '/warehouse',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSpecializedDonorsRoute =
  ProtectedSpecializedDonorsRouteImport.update({
    id: '/specialized-donors',
    path: '/specialized-donors',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedSettingsRoute = ProtectedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedReportsRoute = ProtectedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedRecipientsRoute = ProtectedRecipientsRouteImport.update({
  id: '/recipients',
  path: '/recipients',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedProcessingRoute = ProtectedProcessingRouteImport.update({
  id: '/processing',
  path: '/processing',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedLaboratoryRoute = ProtectedLaboratoryRouteImport.update({
  id: '/laboratory',
  path: '/laboratory',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedLabarotaroyResearchRoute =
  ProtectedLabarotaroyResearchRouteImport.update({
    id: '/labarotaroyResearch',
    path: '/labarotaroyResearch',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedHomeRoute = ProtectedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedExpeditionRoute = ProtectedExpeditionRouteImport.update({
  id: '/expedition',
  path: '/expedition',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDonorsRoute = ProtectedDonorsRouteImport.update({
  id: '/donors',
  path: '/donors',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDonationsRoute = ProtectedDonationsRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDictionaryRoute = ProtectedDictionaryRouteImport.update({
  id: '/dictionary',
  path: '/dictionary',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedContractsRoute = ProtectedContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWarehouseIndexRoute = ProtectedWarehouseIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedWarehouseRoute,
} as any)
const ProtectedLaboratoryIndexRoute =
  ProtectedLaboratoryIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLaboratoryRoute,
  } as any)
const ProtectedLabarotaroyResearchIndexRoute =
  ProtectedLabarotaroyResearchIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLabarotaroyResearchRoute,
  } as any)
const ProtectedDonorsIndexRoute = ProtectedDonorsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedDonorsRoute,
} as any)
const ProtectedContractsIndexRoute = ProtectedContractsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedContractsRoute,
} as any)
const ProtectedWarehouseStockRoute = ProtectedWarehouseStockRouteImport.update({
  id: '/stock',
  path: '/stock',
  getParentRoute: () => ProtectedWarehouseRoute,
} as any)
const ProtectedWarehouseIssuanceRoute =
  ProtectedWarehouseIssuanceRouteImport.update({
    id: '/issuance',
    path: '/issuance',
    getParentRoute: () => ProtectedWarehouseRoute,
  } as any)
const ProtectedWarehouseContainersRoute =
  ProtectedWarehouseContainersRouteImport.update({
    id: '/containers',
    path: '/containers',
    getParentRoute: () => ProtectedWarehouseRoute,
  } as any)
const ProtectedWarehouseApplicationsRoute =
  ProtectedWarehouseApplicationsRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => ProtectedWarehouseRoute,
  } as any)
const ProtectedLaboratoryOrderIdRoute =
  ProtectedLaboratoryOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => ProtectedLaboratoryRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdRoute =
  ProtectedLabarotaroyResearchVisitIdRouteImport.update({
    id: '/$visitId',
    path: '/$visitId',
    getParentRoute: () => ProtectedLabarotaroyResearchRoute,
  } as any)
const ProtectedExpeditionStorageRoute =
  ProtectedExpeditionStorageRouteImport.update({
    id: '/storage',
    path: '/storage',
    getParentRoute: () => ProtectedExpeditionRoute,
  } as any)
const ProtectedExpeditionSecondaryProcessingRoute =
  ProtectedExpeditionSecondaryProcessingRouteImport.update({
    id: '/secondary-processing',
    path: '/secondary-processing',
    getParentRoute: () => ProtectedExpeditionRoute,
  } as any)
const ProtectedExpeditionQualityControlRoute =
  ProtectedExpeditionQualityControlRouteImport.update({
    id: '/quality-control',
    path: '/quality-control',
    getParentRoute: () => ProtectedExpeditionRoute,
  } as any)
const ProtectedExpeditionFractionationRoute =
  ProtectedExpeditionFractionationRouteImport.update({
    id: '/fractionation',
    path: '/fractionation',
    getParentRoute: () => ProtectedExpeditionRoute,
  } as any)
const ProtectedExpeditionCryoprecipitateRoute =
  ProtectedExpeditionCryoprecipitateRouteImport.update({
    id: '/cryoprecipitate',
    path: '/cryoprecipitate',
    getParentRoute: () => ProtectedExpeditionRoute,
  } as any)
const ProtectedDonorsVisitIdRoute = ProtectedDonorsVisitIdRouteImport.update({
  id: '/$visitId',
  path: '/$visitId',
  getParentRoute: () => ProtectedDonorsRoute,
} as any)
const ProtectedDictionaryAnalysisRoute =
  ProtectedDictionaryAnalysisRouteImport.update({
    id: '/analysis',
    path: '/analysis',
    getParentRoute: () => ProtectedDictionaryRoute,
  } as any)
const ProtectedContractsTypeRoute = ProtectedContractsTypeRouteImport.update({
  id: '/$type',
  path: '/$type',
  getParentRoute: () => ProtectedContractsRoute,
} as any)
const ProtectedRecipientsTransfusionsIndexRoute =
  ProtectedRecipientsTransfusionsIndexRouteImport.update({
    id: '/transfusions/',
    path: '/transfusions/',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedRecipientsListIndexRoute =
  ProtectedRecipientsListIndexRouteImport.update({
    id: '/list/',
    path: '/list/',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedRecipientsBloodConsumptionIndexRoute =
  ProtectedRecipientsBloodConsumptionIndexRouteImport.update({
    id: '/blood-consumption/',
    path: '/blood-consumption/',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdIndexRoute =
  ProtectedLabarotaroyResearchVisitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdIndexRoute =
  ProtectedDonorsVisitIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDictionaryOrganizationsIndexRoute =
  ProtectedDictionaryOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => ProtectedDictionaryRoute,
  } as any)
const ProtectedRecipientsTransfusionsNewRoute =
  ProtectedRecipientsTransfusionsNewRouteImport.update({
    id: '/transfusions/new',
    path: '/transfusions/new',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedRecipientsTransfusionsTransfusionIdRoute =
  ProtectedRecipientsTransfusionsTransfusionIdRouteImport.update({
    id: '/transfusions/$transfusionId',
    path: '/transfusions/$transfusionId',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedRecipientsBloodConsumptionNewRoute =
  ProtectedRecipientsBloodConsumptionNewRouteImport.update({
    id: '/blood-consumption/new',
    path: '/blood-consumption/new',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedRecipientsBloodConsumptionProtocolIdRoute =
  ProtectedRecipientsBloodConsumptionProtocolIdRouteImport.update({
    id: '/blood-consumption/$protocolId',
    path: '/blood-consumption/$protocolId',
    getParentRoute: () => ProtectedRecipientsRoute,
  } as any)
const ProtectedLaboratoryNotificationsNewRoute =
  ProtectedLaboratoryNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => ProtectedLaboratoryRoute,
  } as any)
const ProtectedLaboratoryNotificationsNotificationIdRoute =
  ProtectedLaboratoryNotificationsNotificationIdRouteImport.update({
    id: '/notifications/$notificationId',
    path: '/notifications/$notificationId',
    getParentRoute: () => ProtectedLaboratoryRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdScreeningRoute =
  ProtectedLabarotaroyResearchVisitIdScreeningRouteImport.update({
    id: '/screening',
    path: '/screening',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute =
  ProtectedLabarotaroyResearchVisitIdMedicalSurveyRouteImport.update({
    id: '/medical-survey',
    path: '/medical-survey',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute =
  ProtectedLabarotaroyResearchVisitIdMedicalHistoryRouteImport.update({
    id: '/medical-history',
    path: '/medical-history',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdDonationRoute =
  ProtectedLabarotaroyResearchVisitIdDonationRouteImport.update({
    id: '/donation',
    path: '/donation',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdDeferredRoute =
  ProtectedLabarotaroyResearchVisitIdDeferredRouteImport.update({
    id: '/deferred',
    path: '/deferred',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute =
  ProtectedLabarotaroyResearchVisitIdBloodCollectionRouteImport.update({
    id: '/blood-collection',
    path: '/blood-collection',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdScreeningRoute =
  ProtectedDonorsVisitIdScreeningRouteImport.update({
    id: '/screening',
    path: '/screening',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdMedicalSurveyRoute =
  ProtectedDonorsVisitIdMedicalSurveyRouteImport.update({
    id: '/medical-survey',
    path: '/medical-survey',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdMedicalHistoryRoute =
  ProtectedDonorsVisitIdMedicalHistoryRouteImport.update({
    id: '/medical-history',
    path: '/medical-history',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdDonationRoute =
  ProtectedDonorsVisitIdDonationRouteImport.update({
    id: '/donation',
    path: '/donation',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdDocumentsRoute =
  ProtectedDonorsVisitIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdDeferredRoute =
  ProtectedDonorsVisitIdDeferredRouteImport.update({
    id: '/deferred',
    path: '/deferred',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdBloodCollectionRoute =
  ProtectedDonorsVisitIdBloodCollectionRouteImport.update({
    id: '/blood-collection',
    path: '/blood-collection',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedDictionaryOrganizationsNewRoute =
  ProtectedDictionaryOrganizationsNewRouteImport.update({
    id: '/organizations/new',
    path: '/organizations/new',
    getParentRoute: () => ProtectedDictionaryRoute,
  } as any)
const ProtectedDictionaryOrganizationsInnRoute =
  ProtectedDictionaryOrganizationsInnRouteImport.update({
    id: '/organizations/$inn',
    path: '/organizations/$inn',
    getParentRoute: () => ProtectedDictionaryRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute =
  ProtectedLabarotaroyResearchVisitIdLabResearchIndexRouteImport.update({
    id: '/lab-research/',
    path: '/lab-research/',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdLabResearchIndexRoute =
  ProtectedDonorsVisitIdLabResearchIndexRouteImport.update({
    id: '/lab-research/',
    path: '/lab-research/',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)
const ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute =
  ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRouteImport.update({
    id: '/lab-research/$researchId',
    path: '/lab-research/$researchId',
    getParentRoute: () => ProtectedLabarotaroyResearchVisitIdRoute,
  } as any)
const ProtectedDonorsVisitIdLabResearchResearchIdRoute =
  ProtectedDonorsVisitIdLabResearchResearchIdRouteImport.update({
    id: '/lab-research/$researchId',
    path: '/lab-research/$researchId',
    getParentRoute: () => ProtectedDonorsVisitIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/contracts': typeof ProtectedContractsRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/dictionary': typeof ProtectedDictionaryRouteWithChildren
  '/donations': typeof ProtectedDonationsRoute
  '/donors': typeof ProtectedDonorsRouteWithChildren
  '/expedition': typeof ProtectedExpeditionRouteWithChildren
  '/home': typeof ProtectedHomeRoute
  '/labarotaroyResearch': typeof ProtectedLabarotaroyResearchRouteWithChildren
  '/laboratory': typeof ProtectedLaboratoryRouteWithChildren
  '/processing': typeof ProtectedProcessingRoute
  '/recipients': typeof ProtectedRecipientsRouteWithChildren
  '/reports': typeof ProtectedReportsRoute
  '/settings': typeof ProtectedSettingsRoute
  '/specialized-donors': typeof ProtectedSpecializedDonorsRoute
  '/warehouse': typeof ProtectedWarehouseRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/entry': typeof AuthEntryRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/contracts/$type': typeof ProtectedContractsTypeRoute
  '/dictionary/analysis': typeof ProtectedDictionaryAnalysisRoute
  '/donors/$visitId': typeof ProtectedDonorsVisitIdRouteWithChildren
  '/expedition/cryoprecipitate': typeof ProtectedExpeditionCryoprecipitateRoute
  '/expedition/fractionation': typeof ProtectedExpeditionFractionationRoute
  '/expedition/quality-control': typeof ProtectedExpeditionQualityControlRoute
  '/expedition/secondary-processing': typeof ProtectedExpeditionSecondaryProcessingRoute
  '/expedition/storage': typeof ProtectedExpeditionStorageRoute
  '/labarotaroyResearch/$visitId': typeof ProtectedLabarotaroyResearchVisitIdRouteWithChildren
  '/laboratory/$orderId': typeof ProtectedLaboratoryOrderIdRoute
  '/warehouse/applications': typeof ProtectedWarehouseApplicationsRoute
  '/warehouse/containers': typeof ProtectedWarehouseContainersRoute
  '/warehouse/issuance': typeof ProtectedWarehouseIssuanceRoute
  '/warehouse/stock': typeof ProtectedWarehouseStockRoute
  '/contracts/': typeof ProtectedContractsIndexRoute
  '/donors/': typeof ProtectedDonorsIndexRoute
  '/labarotaroyResearch/': typeof ProtectedLabarotaroyResearchIndexRoute
  '/laboratory/': typeof ProtectedLaboratoryIndexRoute
  '/warehouse/': typeof ProtectedWarehouseIndexRoute
  '/dictionary/organizations/$inn': typeof ProtectedDictionaryOrganizationsInnRoute
  '/dictionary/organizations/new': typeof ProtectedDictionaryOrganizationsNewRoute
  '/donors/$visitId/blood-collection': typeof ProtectedDonorsVisitIdBloodCollectionRoute
  '/donors/$visitId/deferred': typeof ProtectedDonorsVisitIdDeferredRoute
  '/donors/$visitId/documents': typeof ProtectedDonorsVisitIdDocumentsRoute
  '/donors/$visitId/donation': typeof ProtectedDonorsVisitIdDonationRoute
  '/donors/$visitId/medical-history': typeof ProtectedDonorsVisitIdMedicalHistoryRoute
  '/donors/$visitId/medical-survey': typeof ProtectedDonorsVisitIdMedicalSurveyRoute
  '/donors/$visitId/screening': typeof ProtectedDonorsVisitIdScreeningRoute
  '/labarotaroyResearch/$visitId/blood-collection': typeof ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute
  '/labarotaroyResearch/$visitId/deferred': typeof ProtectedLabarotaroyResearchVisitIdDeferredRoute
  '/labarotaroyResearch/$visitId/donation': typeof ProtectedLabarotaroyResearchVisitIdDonationRoute
  '/labarotaroyResearch/$visitId/medical-history': typeof ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute
  '/labarotaroyResearch/$visitId/medical-survey': typeof ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute
  '/labarotaroyResearch/$visitId/screening': typeof ProtectedLabarotaroyResearchVisitIdScreeningRoute
  '/laboratory/notifications/$notificationId': typeof ProtectedLaboratoryNotificationsNotificationIdRoute
  '/laboratory/notifications/new': typeof ProtectedLaboratoryNotificationsNewRoute
  '/recipients/blood-consumption/$protocolId': typeof ProtectedRecipientsBloodConsumptionProtocolIdRoute
  '/recipients/blood-consumption/new': typeof ProtectedRecipientsBloodConsumptionNewRoute
  '/recipients/transfusions/$transfusionId': typeof ProtectedRecipientsTransfusionsTransfusionIdRoute
  '/recipients/transfusions/new': typeof ProtectedRecipientsTransfusionsNewRoute
  '/dictionary/organizations/': typeof ProtectedDictionaryOrganizationsIndexRoute
  '/donors/$visitId/': typeof ProtectedDonorsVisitIdIndexRoute
  '/labarotaroyResearch/$visitId/': typeof ProtectedLabarotaroyResearchVisitIdIndexRoute
  '/recipients/blood-consumption/': typeof ProtectedRecipientsBloodConsumptionIndexRoute
  '/recipients/list/': typeof ProtectedRecipientsListIndexRoute
  '/recipients/transfusions/': typeof ProtectedRecipientsTransfusionsIndexRoute
  '/donors/$visitId/lab-research/$researchId': typeof ProtectedDonorsVisitIdLabResearchResearchIdRoute
  '/labarotaroyResearch/$visitId/lab-research/$researchId': typeof ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute
  '/donors/$visitId/lab-research/': typeof ProtectedDonorsVisitIdLabResearchIndexRoute
  '/labarotaroyResearch/$visitId/lab-research/': typeof ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/dictionary': typeof ProtectedDictionaryRouteWithChildren
  '/donations': typeof ProtectedDonationsRoute
  '/expedition': typeof ProtectedExpeditionRouteWithChildren
  '/home': typeof ProtectedHomeRoute
  '/processing': typeof ProtectedProcessingRoute
  '/recipients': typeof ProtectedRecipientsRouteWithChildren
  '/reports': typeof ProtectedReportsRoute
  '/settings': typeof ProtectedSettingsRoute
  '/specialized-donors': typeof ProtectedSpecializedDonorsRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/entry': typeof AuthEntryRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/contracts/$type': typeof ProtectedContractsTypeRoute
  '/dictionary/analysis': typeof ProtectedDictionaryAnalysisRoute
  '/expedition/cryoprecipitate': typeof ProtectedExpeditionCryoprecipitateRoute
  '/expedition/fractionation': typeof ProtectedExpeditionFractionationRoute
  '/expedition/quality-control': typeof ProtectedExpeditionQualityControlRoute
  '/expedition/secondary-processing': typeof ProtectedExpeditionSecondaryProcessingRoute
  '/expedition/storage': typeof ProtectedExpeditionStorageRoute
  '/laboratory/$orderId': typeof ProtectedLaboratoryOrderIdRoute
  '/warehouse/applications': typeof ProtectedWarehouseApplicationsRoute
  '/warehouse/containers': typeof ProtectedWarehouseContainersRoute
  '/warehouse/issuance': typeof ProtectedWarehouseIssuanceRoute
  '/warehouse/stock': typeof ProtectedWarehouseStockRoute
  '/contracts': typeof ProtectedContractsIndexRoute
  '/donors': typeof ProtectedDonorsIndexRoute
  '/labarotaroyResearch': typeof ProtectedLabarotaroyResearchIndexRoute
  '/laboratory': typeof ProtectedLaboratoryIndexRoute
  '/warehouse': typeof ProtectedWarehouseIndexRoute
  '/dictionary/organizations/$inn': typeof ProtectedDictionaryOrganizationsInnRoute
  '/dictionary/organizations/new': typeof ProtectedDictionaryOrganizationsNewRoute
  '/donors/$visitId/blood-collection': typeof ProtectedDonorsVisitIdBloodCollectionRoute
  '/donors/$visitId/deferred': typeof ProtectedDonorsVisitIdDeferredRoute
  '/donors/$visitId/documents': typeof ProtectedDonorsVisitIdDocumentsRoute
  '/donors/$visitId/donation': typeof ProtectedDonorsVisitIdDonationRoute
  '/donors/$visitId/medical-history': typeof ProtectedDonorsVisitIdMedicalHistoryRoute
  '/donors/$visitId/medical-survey': typeof ProtectedDonorsVisitIdMedicalSurveyRoute
  '/donors/$visitId/screening': typeof ProtectedDonorsVisitIdScreeningRoute
  '/labarotaroyResearch/$visitId/blood-collection': typeof ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute
  '/labarotaroyResearch/$visitId/deferred': typeof ProtectedLabarotaroyResearchVisitIdDeferredRoute
  '/labarotaroyResearch/$visitId/donation': typeof ProtectedLabarotaroyResearchVisitIdDonationRoute
  '/labarotaroyResearch/$visitId/medical-history': typeof ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute
  '/labarotaroyResearch/$visitId/medical-survey': typeof ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute
  '/labarotaroyResearch/$visitId/screening': typeof ProtectedLabarotaroyResearchVisitIdScreeningRoute
  '/laboratory/notifications/$notificationId': typeof ProtectedLaboratoryNotificationsNotificationIdRoute
  '/laboratory/notifications/new': typeof ProtectedLaboratoryNotificationsNewRoute
  '/recipients/blood-consumption/$protocolId': typeof ProtectedRecipientsBloodConsumptionProtocolIdRoute
  '/recipients/blood-consumption/new': typeof ProtectedRecipientsBloodConsumptionNewRoute
  '/recipients/transfusions/$transfusionId': typeof ProtectedRecipientsTransfusionsTransfusionIdRoute
  '/recipients/transfusions/new': typeof ProtectedRecipientsTransfusionsNewRoute
  '/dictionary/organizations': typeof ProtectedDictionaryOrganizationsIndexRoute
  '/donors/$visitId': typeof ProtectedDonorsVisitIdIndexRoute
  '/labarotaroyResearch/$visitId': typeof ProtectedLabarotaroyResearchVisitIdIndexRoute
  '/recipients/blood-consumption': typeof ProtectedRecipientsBloodConsumptionIndexRoute
  '/recipients/list': typeof ProtectedRecipientsListIndexRoute
  '/recipients/transfusions': typeof ProtectedRecipientsTransfusionsIndexRoute
  '/donors/$visitId/lab-research/$researchId': typeof ProtectedDonorsVisitIdLabResearchResearchIdRoute
  '/labarotaroyResearch/$visitId/lab-research/$researchId': typeof ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute
  '/donors/$visitId/lab-research': typeof ProtectedDonorsVisitIdLabResearchIndexRoute
  '/labarotaroyResearch/$visitId/lab-research': typeof ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/_protected/contracts': typeof ProtectedContractsRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/dictionary': typeof ProtectedDictionaryRouteWithChildren
  '/_protected/donations': typeof ProtectedDonationsRoute
  '/_protected/donors': typeof ProtectedDonorsRouteWithChildren
  '/_protected/expedition': typeof ProtectedExpeditionRouteWithChildren
  '/_protected/home': typeof ProtectedHomeRoute
  '/_protected/labarotaroyResearch': typeof ProtectedLabarotaroyResearchRouteWithChildren
  '/_protected/laboratory': typeof ProtectedLaboratoryRouteWithChildren
  '/_protected/processing': typeof ProtectedProcessingRoute
  '/_protected/recipients': typeof ProtectedRecipientsRouteWithChildren
  '/_protected/reports': typeof ProtectedReportsRoute
  '/_protected/settings': typeof ProtectedSettingsRoute
  '/_protected/specialized-donors': typeof ProtectedSpecializedDonorsRoute
  '/_protected/warehouse': typeof ProtectedWarehouseRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/auth/entry': typeof AuthEntryRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/_protected/contracts/$type': typeof ProtectedContractsTypeRoute
  '/_protected/dictionary/analysis': typeof ProtectedDictionaryAnalysisRoute
  '/_protected/donors/$visitId': typeof ProtectedDonorsVisitIdRouteWithChildren
  '/_protected/expedition/cryoprecipitate': typeof ProtectedExpeditionCryoprecipitateRoute
  '/_protected/expedition/fractionation': typeof ProtectedExpeditionFractionationRoute
  '/_protected/expedition/quality-control': typeof ProtectedExpeditionQualityControlRoute
  '/_protected/expedition/secondary-processing': typeof ProtectedExpeditionSecondaryProcessingRoute
  '/_protected/expedition/storage': typeof ProtectedExpeditionStorageRoute
  '/_protected/labarotaroyResearch/$visitId': typeof ProtectedLabarotaroyResearchVisitIdRouteWithChildren
  '/_protected/laboratory/$orderId': typeof ProtectedLaboratoryOrderIdRoute
  '/_protected/warehouse/applications': typeof ProtectedWarehouseApplicationsRoute
  '/_protected/warehouse/containers': typeof ProtectedWarehouseContainersRoute
  '/_protected/warehouse/issuance': typeof ProtectedWarehouseIssuanceRoute
  '/_protected/warehouse/stock': typeof ProtectedWarehouseStockRoute
  '/_protected/contracts/': typeof ProtectedContractsIndexRoute
  '/_protected/donors/': typeof ProtectedDonorsIndexRoute
  '/_protected/labarotaroyResearch/': typeof ProtectedLabarotaroyResearchIndexRoute
  '/_protected/laboratory/': typeof ProtectedLaboratoryIndexRoute
  '/_protected/warehouse/': typeof ProtectedWarehouseIndexRoute
  '/_protected/dictionary/organizations/$inn': typeof ProtectedDictionaryOrganizationsInnRoute
  '/_protected/dictionary/organizations/new': typeof ProtectedDictionaryOrganizationsNewRoute
  '/_protected/donors/$visitId/blood-collection': typeof ProtectedDonorsVisitIdBloodCollectionRoute
  '/_protected/donors/$visitId/deferred': typeof ProtectedDonorsVisitIdDeferredRoute
  '/_protected/donors/$visitId/documents': typeof ProtectedDonorsVisitIdDocumentsRoute
  '/_protected/donors/$visitId/donation': typeof ProtectedDonorsVisitIdDonationRoute
  '/_protected/donors/$visitId/medical-history': typeof ProtectedDonorsVisitIdMedicalHistoryRoute
  '/_protected/donors/$visitId/medical-survey': typeof ProtectedDonorsVisitIdMedicalSurveyRoute
  '/_protected/donors/$visitId/screening': typeof ProtectedDonorsVisitIdScreeningRoute
  '/_protected/labarotaroyResearch/$visitId/blood-collection': typeof ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute
  '/_protected/labarotaroyResearch/$visitId/deferred': typeof ProtectedLabarotaroyResearchVisitIdDeferredRoute
  '/_protected/labarotaroyResearch/$visitId/donation': typeof ProtectedLabarotaroyResearchVisitIdDonationRoute
  '/_protected/labarotaroyResearch/$visitId/medical-history': typeof ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute
  '/_protected/labarotaroyResearch/$visitId/medical-survey': typeof ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute
  '/_protected/labarotaroyResearch/$visitId/screening': typeof ProtectedLabarotaroyResearchVisitIdScreeningRoute
  '/_protected/laboratory/notifications/$notificationId': typeof ProtectedLaboratoryNotificationsNotificationIdRoute
  '/_protected/laboratory/notifications/new': typeof ProtectedLaboratoryNotificationsNewRoute
  '/_protected/recipients/blood-consumption/$protocolId': typeof ProtectedRecipientsBloodConsumptionProtocolIdRoute
  '/_protected/recipients/blood-consumption/new': typeof ProtectedRecipientsBloodConsumptionNewRoute
  '/_protected/recipients/transfusions/$transfusionId': typeof ProtectedRecipientsTransfusionsTransfusionIdRoute
  '/_protected/recipients/transfusions/new': typeof ProtectedRecipientsTransfusionsNewRoute
  '/_protected/dictionary/organizations/': typeof ProtectedDictionaryOrganizationsIndexRoute
  '/_protected/donors/$visitId/': typeof ProtectedDonorsVisitIdIndexRoute
  '/_protected/labarotaroyResearch/$visitId/': typeof ProtectedLabarotaroyResearchVisitIdIndexRoute
  '/_protected/recipients/blood-consumption/': typeof ProtectedRecipientsBloodConsumptionIndexRoute
  '/_protected/recipients/list/': typeof ProtectedRecipientsListIndexRoute
  '/_protected/recipients/transfusions/': typeof ProtectedRecipientsTransfusionsIndexRoute
  '/_protected/donors/$visitId/lab-research/$researchId': typeof ProtectedDonorsVisitIdLabResearchResearchIdRoute
  '/_protected/labarotaroyResearch/$visitId/lab-research/$researchId': typeof ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute
  '/_protected/donors/$visitId/lab-research/': typeof ProtectedDonorsVisitIdLabResearchIndexRoute
  '/_protected/labarotaroyResearch/$visitId/lab-research/': typeof ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/forbidden'
    | '/contracts'
    | '/dashboard'
    | '/dictionary'
    | '/donations'
    | '/donors'
    | '/expedition'
    | '/home'
    | '/labarotaroyResearch'
    | '/laboratory'
    | '/processing'
    | '/recipients'
    | '/reports'
    | '/settings'
    | '/specialized-donors'
    | '/warehouse'
    | '/auth/callback'
    | '/auth/entry'
    | '/auth/login'
    | '/auth/register'
    | '/verify/$token'
    | '/contracts/$type'
    | '/dictionary/analysis'
    | '/donors/$visitId'
    | '/expedition/cryoprecipitate'
    | '/expedition/fractionation'
    | '/expedition/quality-control'
    | '/expedition/secondary-processing'
    | '/expedition/storage'
    | '/labarotaroyResearch/$visitId'
    | '/laboratory/$orderId'
    | '/warehouse/applications'
    | '/warehouse/containers'
    | '/warehouse/issuance'
    | '/warehouse/stock'
    | '/contracts/'
    | '/donors/'
    | '/labarotaroyResearch/'
    | '/laboratory/'
    | '/warehouse/'
    | '/dictionary/organizations/$inn'
    | '/dictionary/organizations/new'
    | '/donors/$visitId/blood-collection'
    | '/donors/$visitId/deferred'
    | '/donors/$visitId/documents'
    | '/donors/$visitId/donation'
    | '/donors/$visitId/medical-history'
    | '/donors/$visitId/medical-survey'
    | '/donors/$visitId/screening'
    | '/labarotaroyResearch/$visitId/blood-collection'
    | '/labarotaroyResearch/$visitId/deferred'
    | '/labarotaroyResearch/$visitId/donation'
    | '/labarotaroyResearch/$visitId/medical-history'
    | '/labarotaroyResearch/$visitId/medical-survey'
    | '/labarotaroyResearch/$visitId/screening'
    | '/laboratory/notifications/$notificationId'
    | '/laboratory/notifications/new'
    | '/recipients/blood-consumption/$protocolId'
    | '/recipients/blood-consumption/new'
    | '/recipients/transfusions/$transfusionId'
    | '/recipients/transfusions/new'
    | '/dictionary/organizations/'
    | '/donors/$visitId/'
    | '/labarotaroyResearch/$visitId/'
    | '/recipients/blood-consumption/'
    | '/recipients/list/'
    | '/recipients/transfusions/'
    | '/donors/$visitId/lab-research/$researchId'
    | '/labarotaroyResearch/$visitId/lab-research/$researchId'
    | '/donors/$visitId/lab-research/'
    | '/labarotaroyResearch/$visitId/lab-research/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/forbidden'
    | '/dashboard'
    | '/dictionary'
    | '/donations'
    | '/expedition'
    | '/home'
    | '/processing'
    | '/recipients'
    | '/reports'
    | '/settings'
    | '/specialized-donors'
    | '/auth/callback'
    | '/auth/entry'
    | '/auth/login'
    | '/auth/register'
    | '/verify/$token'
    | '/contracts/$type'
    | '/dictionary/analysis'
    | '/expedition/cryoprecipitate'
    | '/expedition/fractionation'
    | '/expedition/quality-control'
    | '/expedition/secondary-processing'
    | '/expedition/storage'
    | '/laboratory/$orderId'
    | '/warehouse/applications'
    | '/warehouse/containers'
    | '/warehouse/issuance'
    | '/warehouse/stock'
    | '/contracts'
    | '/donors'
    | '/labarotaroyResearch'
    | '/laboratory'
    | '/warehouse'
    | '/dictionary/organizations/$inn'
    | '/dictionary/organizations/new'
    | '/donors/$visitId/blood-collection'
    | '/donors/$visitId/deferred'
    | '/donors/$visitId/documents'
    | '/donors/$visitId/donation'
    | '/donors/$visitId/medical-history'
    | '/donors/$visitId/medical-survey'
    | '/donors/$visitId/screening'
    | '/labarotaroyResearch/$visitId/blood-collection'
    | '/labarotaroyResearch/$visitId/deferred'
    | '/labarotaroyResearch/$visitId/donation'
    | '/labarotaroyResearch/$visitId/medical-history'
    | '/labarotaroyResearch/$visitId/medical-survey'
    | '/labarotaroyResearch/$visitId/screening'
    | '/laboratory/notifications/$notificationId'
    | '/laboratory/notifications/new'
    | '/recipients/blood-consumption/$protocolId'
    | '/recipients/blood-consumption/new'
    | '/recipients/transfusions/$transfusionId'
    | '/recipients/transfusions/new'
    | '/dictionary/organizations'
    | '/donors/$visitId'
    | '/labarotaroyResearch/$visitId'
    | '/recipients/blood-consumption'
    | '/recipients/list'
    | '/recipients/transfusions'
    | '/donors/$visitId/lab-research/$researchId'
    | '/labarotaroyResearch/$visitId/lab-research/$researchId'
    | '/donors/$visitId/lab-research'
    | '/labarotaroyResearch/$visitId/lab-research'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/auth'
    | '/forbidden'
    | '/_protected/contracts'
    | '/_protected/dashboard'
    | '/_protected/dictionary'
    | '/_protected/donations'
    | '/_protected/donors'
    | '/_protected/expedition'
    | '/_protected/home'
    | '/_protected/labarotaroyResearch'
    | '/_protected/laboratory'
    | '/_protected/processing'
    | '/_protected/recipients'
    | '/_protected/reports'
    | '/_protected/settings'
    | '/_protected/specialized-donors'
    | '/_protected/warehouse'
    | '/auth/callback'
    | '/auth/entry'
    | '/auth/login'
    | '/auth/register'
    | '/verify/$token'
    | '/_protected/contracts/$type'
    | '/_protected/dictionary/analysis'
    | '/_protected/donors/$visitId'
    | '/_protected/expedition/cryoprecipitate'
    | '/_protected/expedition/fractionation'
    | '/_protected/expedition/quality-control'
    | '/_protected/expedition/secondary-processing'
    | '/_protected/expedition/storage'
    | '/_protected/labarotaroyResearch/$visitId'
    | '/_protected/laboratory/$orderId'
    | '/_protected/warehouse/applications'
    | '/_protected/warehouse/containers'
    | '/_protected/warehouse/issuance'
    | '/_protected/warehouse/stock'
    | '/_protected/contracts/'
    | '/_protected/donors/'
    | '/_protected/labarotaroyResearch/'
    | '/_protected/laboratory/'
    | '/_protected/warehouse/'
    | '/_protected/dictionary/organizations/$inn'
    | '/_protected/dictionary/organizations/new'
    | '/_protected/donors/$visitId/blood-collection'
    | '/_protected/donors/$visitId/deferred'
    | '/_protected/donors/$visitId/documents'
    | '/_protected/donors/$visitId/donation'
    | '/_protected/donors/$visitId/medical-history'
    | '/_protected/donors/$visitId/medical-survey'
    | '/_protected/donors/$visitId/screening'
    | '/_protected/labarotaroyResearch/$visitId/blood-collection'
    | '/_protected/labarotaroyResearch/$visitId/deferred'
    | '/_protected/labarotaroyResearch/$visitId/donation'
    | '/_protected/labarotaroyResearch/$visitId/medical-history'
    | '/_protected/labarotaroyResearch/$visitId/medical-survey'
    | '/_protected/labarotaroyResearch/$visitId/screening'
    | '/_protected/laboratory/notifications/$notificationId'
    | '/_protected/laboratory/notifications/new'
    | '/_protected/recipients/blood-consumption/$protocolId'
    | '/_protected/recipients/blood-consumption/new'
    | '/_protected/recipients/transfusions/$transfusionId'
    | '/_protected/recipients/transfusions/new'
    | '/_protected/dictionary/organizations/'
    | '/_protected/donors/$visitId/'
    | '/_protected/labarotaroyResearch/$visitId/'
    | '/_protected/recipients/blood-consumption/'
    | '/_protected/recipients/list/'
    | '/_protected/recipients/transfusions/'
    | '/_protected/donors/$visitId/lab-research/$researchId'
    | '/_protected/labarotaroyResearch/$visitId/lab-research/$researchId'
    | '/_protected/donors/$visitId/lab-research/'
    | '/_protected/labarotaroyResearch/$visitId/lab-research/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  VerifyTokenRoute: typeof VerifyTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify/$token': {
      id: '/verify/$token'
      path: '/verify/$token'
      fullPath: '/verify/$token'
      preLoaderRoute: typeof VerifyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/entry': {
      id: '/auth/entry'
      path: '/entry'
      fullPath: '/auth/entry'
      preLoaderRoute: typeof AuthEntryRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/warehouse': {
      id: '/_protected/warehouse'
      path: '/warehouse'
      fullPath: '/warehouse'
      preLoaderRoute: typeof ProtectedWarehouseRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/specialized-donors': {
      id: '/_protected/specialized-donors'
      path: '/specialized-donors'
      fullPath: '/specialized-donors'
      preLoaderRoute: typeof ProtectedSpecializedDonorsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/settings': {
      id: '/_protected/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ProtectedSettingsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/reports': {
      id: '/_protected/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ProtectedReportsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/recipients': {
      id: '/_protected/recipients'
      path: '/recipients'
      fullPath: '/recipients'
      preLoaderRoute: typeof ProtectedRecipientsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/processing': {
      id: '/_protected/processing'
      path: '/processing'
      fullPath: '/processing'
      preLoaderRoute: typeof ProtectedProcessingRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/laboratory': {
      id: '/_protected/laboratory'
      path: '/laboratory'
      fullPath: '/laboratory'
      preLoaderRoute: typeof ProtectedLaboratoryRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/labarotaroyResearch': {
      id: '/_protected/labarotaroyResearch'
      path: '/labarotaroyResearch'
      fullPath: '/labarotaroyResearch'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/home': {
      id: '/_protected/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof ProtectedHomeRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/expedition': {
      id: '/_protected/expedition'
      path: '/expedition'
      fullPath: '/expedition'
      preLoaderRoute: typeof ProtectedExpeditionRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/donors': {
      id: '/_protected/donors'
      path: '/donors'
      fullPath: '/donors'
      preLoaderRoute: typeof ProtectedDonorsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/donations': {
      id: '/_protected/donations'
      path: '/donations'
      fullPath: '/donations'
      preLoaderRoute: typeof ProtectedDonationsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dictionary': {
      id: '/_protected/dictionary'
      path: '/dictionary'
      fullPath: '/dictionary'
      preLoaderRoute: typeof ProtectedDictionaryRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/contracts': {
      id: '/_protected/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof ProtectedContractsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/warehouse/': {
      id: '/_protected/warehouse/'
      path: '/'
      fullPath: '/warehouse/'
      preLoaderRoute: typeof ProtectedWarehouseIndexRouteImport
      parentRoute: typeof ProtectedWarehouseRoute
    }
    '/_protected/laboratory/': {
      id: '/_protected/laboratory/'
      path: '/'
      fullPath: '/laboratory/'
      preLoaderRoute: typeof ProtectedLaboratoryIndexRouteImport
      parentRoute: typeof ProtectedLaboratoryRoute
    }
    '/_protected/labarotaroyResearch/': {
      id: '/_protected/labarotaroyResearch/'
      path: '/'
      fullPath: '/labarotaroyResearch/'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchIndexRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchRoute
    }
    '/_protected/donors/': {
      id: '/_protected/donors/'
      path: '/'
      fullPath: '/donors/'
      preLoaderRoute: typeof ProtectedDonorsIndexRouteImport
      parentRoute: typeof ProtectedDonorsRoute
    }
    '/_protected/contracts/': {
      id: '/_protected/contracts/'
      path: '/'
      fullPath: '/contracts/'
      preLoaderRoute: typeof ProtectedContractsIndexRouteImport
      parentRoute: typeof ProtectedContractsRoute
    }
    '/_protected/warehouse/stock': {
      id: '/_protected/warehouse/stock'
      path: '/stock'
      fullPath: '/warehouse/stock'
      preLoaderRoute: typeof ProtectedWarehouseStockRouteImport
      parentRoute: typeof ProtectedWarehouseRoute
    }
    '/_protected/warehouse/issuance': {
      id: '/_protected/warehouse/issuance'
      path: '/issuance'
      fullPath: '/warehouse/issuance'
      preLoaderRoute: typeof ProtectedWarehouseIssuanceRouteImport
      parentRoute: typeof ProtectedWarehouseRoute
    }
    '/_protected/warehouse/containers': {
      id: '/_protected/warehouse/containers'
      path: '/containers'
      fullPath: '/warehouse/containers'
      preLoaderRoute: typeof ProtectedWarehouseContainersRouteImport
      parentRoute: typeof ProtectedWarehouseRoute
    }
    '/_protected/warehouse/applications': {
      id: '/_protected/warehouse/applications'
      path: '/applications'
      fullPath: '/warehouse/applications'
      preLoaderRoute: typeof ProtectedWarehouseApplicationsRouteImport
      parentRoute: typeof ProtectedWarehouseRoute
    }
    '/_protected/laboratory/$orderId': {
      id: '/_protected/laboratory/$orderId'
      path: '/$orderId'
      fullPath: '/laboratory/$orderId'
      preLoaderRoute: typeof ProtectedLaboratoryOrderIdRouteImport
      parentRoute: typeof ProtectedLaboratoryRoute
    }
    '/_protected/labarotaroyResearch/$visitId': {
      id: '/_protected/labarotaroyResearch/$visitId'
      path: '/$visitId'
      fullPath: '/labarotaroyResearch/$visitId'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchRoute
    }
    '/_protected/expedition/storage': {
      id: '/_protected/expedition/storage'
      path: '/storage'
      fullPath: '/expedition/storage'
      preLoaderRoute: typeof ProtectedExpeditionStorageRouteImport
      parentRoute: typeof ProtectedExpeditionRoute
    }
    '/_protected/expedition/secondary-processing': {
      id: '/_protected/expedition/secondary-processing'
      path: '/secondary-processing'
      fullPath: '/expedition/secondary-processing'
      preLoaderRoute: typeof ProtectedExpeditionSecondaryProcessingRouteImport
      parentRoute: typeof ProtectedExpeditionRoute
    }
    '/_protected/expedition/quality-control': {
      id: '/_protected/expedition/quality-control'
      path: '/quality-control'
      fullPath: '/expedition/quality-control'
      preLoaderRoute: typeof ProtectedExpeditionQualityControlRouteImport
      parentRoute: typeof ProtectedExpeditionRoute
    }
    '/_protected/expedition/fractionation': {
      id: '/_protected/expedition/fractionation'
      path: '/fractionation'
      fullPath: '/expedition/fractionation'
      preLoaderRoute: typeof ProtectedExpeditionFractionationRouteImport
      parentRoute: typeof ProtectedExpeditionRoute
    }
    '/_protected/expedition/cryoprecipitate': {
      id: '/_protected/expedition/cryoprecipitate'
      path: '/cryoprecipitate'
      fullPath: '/expedition/cryoprecipitate'
      preLoaderRoute: typeof ProtectedExpeditionCryoprecipitateRouteImport
      parentRoute: typeof ProtectedExpeditionRoute
    }
    '/_protected/donors/$visitId': {
      id: '/_protected/donors/$visitId'
      path: '/$visitId'
      fullPath: '/donors/$visitId'
      preLoaderRoute: typeof ProtectedDonorsVisitIdRouteImport
      parentRoute: typeof ProtectedDonorsRoute
    }
    '/_protected/dictionary/analysis': {
      id: '/_protected/dictionary/analysis'
      path: '/analysis'
      fullPath: '/dictionary/analysis'
      preLoaderRoute: typeof ProtectedDictionaryAnalysisRouteImport
      parentRoute: typeof ProtectedDictionaryRoute
    }
    '/_protected/contracts/$type': {
      id: '/_protected/contracts/$type'
      path: '/$type'
      fullPath: '/contracts/$type'
      preLoaderRoute: typeof ProtectedContractsTypeRouteImport
      parentRoute: typeof ProtectedContractsRoute
    }
    '/_protected/recipients/transfusions/': {
      id: '/_protected/recipients/transfusions/'
      path: '/transfusions'
      fullPath: '/recipients/transfusions/'
      preLoaderRoute: typeof ProtectedRecipientsTransfusionsIndexRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/recipients/list/': {
      id: '/_protected/recipients/list/'
      path: '/list'
      fullPath: '/recipients/list/'
      preLoaderRoute: typeof ProtectedRecipientsListIndexRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/recipients/blood-consumption/': {
      id: '/_protected/recipients/blood-consumption/'
      path: '/blood-consumption'
      fullPath: '/recipients/blood-consumption/'
      preLoaderRoute: typeof ProtectedRecipientsBloodConsumptionIndexRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/labarotaroyResearch/$visitId/': {
      id: '/_protected/labarotaroyResearch/$visitId/'
      path: '/'
      fullPath: '/labarotaroyResearch/$visitId/'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdIndexRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/donors/$visitId/': {
      id: '/_protected/donors/$visitId/'
      path: '/'
      fullPath: '/donors/$visitId/'
      preLoaderRoute: typeof ProtectedDonorsVisitIdIndexRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/dictionary/organizations/': {
      id: '/_protected/dictionary/organizations/'
      path: '/organizations'
      fullPath: '/dictionary/organizations/'
      preLoaderRoute: typeof ProtectedDictionaryOrganizationsIndexRouteImport
      parentRoute: typeof ProtectedDictionaryRoute
    }
    '/_protected/recipients/transfusions/new': {
      id: '/_protected/recipients/transfusions/new'
      path: '/transfusions/new'
      fullPath: '/recipients/transfusions/new'
      preLoaderRoute: typeof ProtectedRecipientsTransfusionsNewRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/recipients/transfusions/$transfusionId': {
      id: '/_protected/recipients/transfusions/$transfusionId'
      path: '/transfusions/$transfusionId'
      fullPath: '/recipients/transfusions/$transfusionId'
      preLoaderRoute: typeof ProtectedRecipientsTransfusionsTransfusionIdRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/recipients/blood-consumption/new': {
      id: '/_protected/recipients/blood-consumption/new'
      path: '/blood-consumption/new'
      fullPath: '/recipients/blood-consumption/new'
      preLoaderRoute: typeof ProtectedRecipientsBloodConsumptionNewRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/recipients/blood-consumption/$protocolId': {
      id: '/_protected/recipients/blood-consumption/$protocolId'
      path: '/blood-consumption/$protocolId'
      fullPath: '/recipients/blood-consumption/$protocolId'
      preLoaderRoute: typeof ProtectedRecipientsBloodConsumptionProtocolIdRouteImport
      parentRoute: typeof ProtectedRecipientsRoute
    }
    '/_protected/laboratory/notifications/new': {
      id: '/_protected/laboratory/notifications/new'
      path: '/notifications/new'
      fullPath: '/laboratory/notifications/new'
      preLoaderRoute: typeof ProtectedLaboratoryNotificationsNewRouteImport
      parentRoute: typeof ProtectedLaboratoryRoute
    }
    '/_protected/laboratory/notifications/$notificationId': {
      id: '/_protected/laboratory/notifications/$notificationId'
      path: '/notifications/$notificationId'
      fullPath: '/laboratory/notifications/$notificationId'
      preLoaderRoute: typeof ProtectedLaboratoryNotificationsNotificationIdRouteImport
      parentRoute: typeof ProtectedLaboratoryRoute
    }
    '/_protected/labarotaroyResearch/$visitId/screening': {
      id: '/_protected/labarotaroyResearch/$visitId/screening'
      path: '/screening'
      fullPath: '/labarotaroyResearch/$visitId/screening'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdScreeningRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/labarotaroyResearch/$visitId/medical-survey': {
      id: '/_protected/labarotaroyResearch/$visitId/medical-survey'
      path: '/medical-survey'
      fullPath: '/labarotaroyResearch/$visitId/medical-survey'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdMedicalSurveyRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/labarotaroyResearch/$visitId/medical-history': {
      id: '/_protected/labarotaroyResearch/$visitId/medical-history'
      path: '/medical-history'
      fullPath: '/labarotaroyResearch/$visitId/medical-history'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdMedicalHistoryRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/labarotaroyResearch/$visitId/donation': {
      id: '/_protected/labarotaroyResearch/$visitId/donation'
      path: '/donation'
      fullPath: '/labarotaroyResearch/$visitId/donation'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdDonationRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/labarotaroyResearch/$visitId/deferred': {
      id: '/_protected/labarotaroyResearch/$visitId/deferred'
      path: '/deferred'
      fullPath: '/labarotaroyResearch/$visitId/deferred'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdDeferredRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/labarotaroyResearch/$visitId/blood-collection': {
      id: '/_protected/labarotaroyResearch/$visitId/blood-collection'
      path: '/blood-collection'
      fullPath: '/labarotaroyResearch/$visitId/blood-collection'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdBloodCollectionRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/donors/$visitId/screening': {
      id: '/_protected/donors/$visitId/screening'
      path: '/screening'
      fullPath: '/donors/$visitId/screening'
      preLoaderRoute: typeof ProtectedDonorsVisitIdScreeningRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/donors/$visitId/medical-survey': {
      id: '/_protected/donors/$visitId/medical-survey'
      path: '/medical-survey'
      fullPath: '/donors/$visitId/medical-survey'
      preLoaderRoute: typeof ProtectedDonorsVisitIdMedicalSurveyRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/donors/$visitId/medical-history': {
      id: '/_protected/donors/$visitId/medical-history'
      path: '/medical-history'
      fullPath: '/donors/$visitId/medical-history'
      preLoaderRoute: typeof ProtectedDonorsVisitIdMedicalHistoryRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/donors/$visitId/donation': {
      id: '/_protected/donors/$visitId/donation'
      path: '/donation'
      fullPath: '/donors/$visitId/donation'
      preLoaderRoute: typeof ProtectedDonorsVisitIdDonationRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/donors/$visitId/documents': {
      id: '/_protected/donors/$visitId/documents'
      path: '/documents'
      fullPath: '/donors/$visitId/documents'
      preLoaderRoute: typeof ProtectedDonorsVisitIdDocumentsRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/donors/$visitId/deferred': {
      id: '/_protected/donors/$visitId/deferred'
      path: '/deferred'
      fullPath: '/donors/$visitId/deferred'
      preLoaderRoute: typeof ProtectedDonorsVisitIdDeferredRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/donors/$visitId/blood-collection': {
      id: '/_protected/donors/$visitId/blood-collection'
      path: '/blood-collection'
      fullPath: '/donors/$visitId/blood-collection'
      preLoaderRoute: typeof ProtectedDonorsVisitIdBloodCollectionRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/dictionary/organizations/new': {
      id: '/_protected/dictionary/organizations/new'
      path: '/organizations/new'
      fullPath: '/dictionary/organizations/new'
      preLoaderRoute: typeof ProtectedDictionaryOrganizationsNewRouteImport
      parentRoute: typeof ProtectedDictionaryRoute
    }
    '/_protected/dictionary/organizations/$inn': {
      id: '/_protected/dictionary/organizations/$inn'
      path: '/organizations/$inn'
      fullPath: '/dictionary/organizations/$inn'
      preLoaderRoute: typeof ProtectedDictionaryOrganizationsInnRouteImport
      parentRoute: typeof ProtectedDictionaryRoute
    }
    '/_protected/labarotaroyResearch/$visitId/lab-research/': {
      id: '/_protected/labarotaroyResearch/$visitId/lab-research/'
      path: '/lab-research'
      fullPath: '/labarotaroyResearch/$visitId/lab-research/'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdLabResearchIndexRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/donors/$visitId/lab-research/': {
      id: '/_protected/donors/$visitId/lab-research/'
      path: '/lab-research'
      fullPath: '/donors/$visitId/lab-research/'
      preLoaderRoute: typeof ProtectedDonorsVisitIdLabResearchIndexRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
    '/_protected/labarotaroyResearch/$visitId/lab-research/$researchId': {
      id: '/_protected/labarotaroyResearch/$visitId/lab-research/$researchId'
      path: '/lab-research/$researchId'
      fullPath: '/labarotaroyResearch/$visitId/lab-research/$researchId'
      preLoaderRoute: typeof ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRouteImport
      parentRoute: typeof ProtectedLabarotaroyResearchVisitIdRoute
    }
    '/_protected/donors/$visitId/lab-research/$researchId': {
      id: '/_protected/donors/$visitId/lab-research/$researchId'
      path: '/lab-research/$researchId'
      fullPath: '/donors/$visitId/lab-research/$researchId'
      preLoaderRoute: typeof ProtectedDonorsVisitIdLabResearchResearchIdRouteImport
      parentRoute: typeof ProtectedDonorsVisitIdRoute
    }
  }
}

interface ProtectedContractsRouteChildren {
  ProtectedContractsTypeRoute: typeof ProtectedContractsTypeRoute
  ProtectedContractsIndexRoute: typeof ProtectedContractsIndexRoute
}

const ProtectedContractsRouteChildren: ProtectedContractsRouteChildren = {
  ProtectedContractsTypeRoute: ProtectedContractsTypeRoute,
  ProtectedContractsIndexRoute: ProtectedContractsIndexRoute,
}

const ProtectedContractsRouteWithChildren =
  ProtectedContractsRoute._addFileChildren(ProtectedContractsRouteChildren)

interface ProtectedDictionaryRouteChildren {
  ProtectedDictionaryAnalysisRoute: typeof ProtectedDictionaryAnalysisRoute
  ProtectedDictionaryOrganizationsInnRoute: typeof ProtectedDictionaryOrganizationsInnRoute
  ProtectedDictionaryOrganizationsNewRoute: typeof ProtectedDictionaryOrganizationsNewRoute
  ProtectedDictionaryOrganizationsIndexRoute: typeof ProtectedDictionaryOrganizationsIndexRoute
}

const ProtectedDictionaryRouteChildren: ProtectedDictionaryRouteChildren = {
  ProtectedDictionaryAnalysisRoute: ProtectedDictionaryAnalysisRoute,
  ProtectedDictionaryOrganizationsInnRoute:
    ProtectedDictionaryOrganizationsInnRoute,
  ProtectedDictionaryOrganizationsNewRoute:
    ProtectedDictionaryOrganizationsNewRoute,
  ProtectedDictionaryOrganizationsIndexRoute:
    ProtectedDictionaryOrganizationsIndexRoute,
}

const ProtectedDictionaryRouteWithChildren =
  ProtectedDictionaryRoute._addFileChildren(ProtectedDictionaryRouteChildren)

interface ProtectedDonorsVisitIdRouteChildren {
  ProtectedDonorsVisitIdBloodCollectionRoute: typeof ProtectedDonorsVisitIdBloodCollectionRoute
  ProtectedDonorsVisitIdDeferredRoute: typeof ProtectedDonorsVisitIdDeferredRoute
  ProtectedDonorsVisitIdDocumentsRoute: typeof ProtectedDonorsVisitIdDocumentsRoute
  ProtectedDonorsVisitIdDonationRoute: typeof ProtectedDonorsVisitIdDonationRoute
  ProtectedDonorsVisitIdMedicalHistoryRoute: typeof ProtectedDonorsVisitIdMedicalHistoryRoute
  ProtectedDonorsVisitIdMedicalSurveyRoute: typeof ProtectedDonorsVisitIdMedicalSurveyRoute
  ProtectedDonorsVisitIdScreeningRoute: typeof ProtectedDonorsVisitIdScreeningRoute
  ProtectedDonorsVisitIdIndexRoute: typeof ProtectedDonorsVisitIdIndexRoute
  ProtectedDonorsVisitIdLabResearchResearchIdRoute: typeof ProtectedDonorsVisitIdLabResearchResearchIdRoute
  ProtectedDonorsVisitIdLabResearchIndexRoute: typeof ProtectedDonorsVisitIdLabResearchIndexRoute
}

const ProtectedDonorsVisitIdRouteChildren: ProtectedDonorsVisitIdRouteChildren =
  {
    ProtectedDonorsVisitIdBloodCollectionRoute:
      ProtectedDonorsVisitIdBloodCollectionRoute,
    ProtectedDonorsVisitIdDeferredRoute: ProtectedDonorsVisitIdDeferredRoute,
    ProtectedDonorsVisitIdDocumentsRoute: ProtectedDonorsVisitIdDocumentsRoute,
    ProtectedDonorsVisitIdDonationRoute: ProtectedDonorsVisitIdDonationRoute,
    ProtectedDonorsVisitIdMedicalHistoryRoute:
      ProtectedDonorsVisitIdMedicalHistoryRoute,
    ProtectedDonorsVisitIdMedicalSurveyRoute:
      ProtectedDonorsVisitIdMedicalSurveyRoute,
    ProtectedDonorsVisitIdScreeningRoute: ProtectedDonorsVisitIdScreeningRoute,
    ProtectedDonorsVisitIdIndexRoute: ProtectedDonorsVisitIdIndexRoute,
    ProtectedDonorsVisitIdLabResearchResearchIdRoute:
      ProtectedDonorsVisitIdLabResearchResearchIdRoute,
    ProtectedDonorsVisitIdLabResearchIndexRoute:
      ProtectedDonorsVisitIdLabResearchIndexRoute,
  }

const ProtectedDonorsVisitIdRouteWithChildren =
  ProtectedDonorsVisitIdRoute._addFileChildren(
    ProtectedDonorsVisitIdRouteChildren,
  )

interface ProtectedDonorsRouteChildren {
  ProtectedDonorsVisitIdRoute: typeof ProtectedDonorsVisitIdRouteWithChildren
  ProtectedDonorsIndexRoute: typeof ProtectedDonorsIndexRoute
}

const ProtectedDonorsRouteChildren: ProtectedDonorsRouteChildren = {
  ProtectedDonorsVisitIdRoute: ProtectedDonorsVisitIdRouteWithChildren,
  ProtectedDonorsIndexRoute: ProtectedDonorsIndexRoute,
}

const ProtectedDonorsRouteWithChildren = ProtectedDonorsRoute._addFileChildren(
  ProtectedDonorsRouteChildren,
)

interface ProtectedExpeditionRouteChildren {
  ProtectedExpeditionCryoprecipitateRoute: typeof ProtectedExpeditionCryoprecipitateRoute
  ProtectedExpeditionFractionationRoute: typeof ProtectedExpeditionFractionationRoute
  ProtectedExpeditionQualityControlRoute: typeof ProtectedExpeditionQualityControlRoute
  ProtectedExpeditionSecondaryProcessingRoute: typeof ProtectedExpeditionSecondaryProcessingRoute
  ProtectedExpeditionStorageRoute: typeof ProtectedExpeditionStorageRoute
}

const ProtectedExpeditionRouteChildren: ProtectedExpeditionRouteChildren = {
  ProtectedExpeditionCryoprecipitateRoute:
    ProtectedExpeditionCryoprecipitateRoute,
  ProtectedExpeditionFractionationRoute: ProtectedExpeditionFractionationRoute,
  ProtectedExpeditionQualityControlRoute:
    ProtectedExpeditionQualityControlRoute,
  ProtectedExpeditionSecondaryProcessingRoute:
    ProtectedExpeditionSecondaryProcessingRoute,
  ProtectedExpeditionStorageRoute: ProtectedExpeditionStorageRoute,
}

const ProtectedExpeditionRouteWithChildren =
  ProtectedExpeditionRoute._addFileChildren(ProtectedExpeditionRouteChildren)

interface ProtectedLabarotaroyResearchVisitIdRouteChildren {
  ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute: typeof ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute
  ProtectedLabarotaroyResearchVisitIdDeferredRoute: typeof ProtectedLabarotaroyResearchVisitIdDeferredRoute
  ProtectedLabarotaroyResearchVisitIdDonationRoute: typeof ProtectedLabarotaroyResearchVisitIdDonationRoute
  ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute: typeof ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute
  ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute: typeof ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute
  ProtectedLabarotaroyResearchVisitIdScreeningRoute: typeof ProtectedLabarotaroyResearchVisitIdScreeningRoute
  ProtectedLabarotaroyResearchVisitIdIndexRoute: typeof ProtectedLabarotaroyResearchVisitIdIndexRoute
  ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute: typeof ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute
  ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute: typeof ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute
}

const ProtectedLabarotaroyResearchVisitIdRouteChildren: ProtectedLabarotaroyResearchVisitIdRouteChildren =
  {
    ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute:
      ProtectedLabarotaroyResearchVisitIdBloodCollectionRoute,
    ProtectedLabarotaroyResearchVisitIdDeferredRoute:
      ProtectedLabarotaroyResearchVisitIdDeferredRoute,
    ProtectedLabarotaroyResearchVisitIdDonationRoute:
      ProtectedLabarotaroyResearchVisitIdDonationRoute,
    ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute:
      ProtectedLabarotaroyResearchVisitIdMedicalHistoryRoute,
    ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute:
      ProtectedLabarotaroyResearchVisitIdMedicalSurveyRoute,
    ProtectedLabarotaroyResearchVisitIdScreeningRoute:
      ProtectedLabarotaroyResearchVisitIdScreeningRoute,
    ProtectedLabarotaroyResearchVisitIdIndexRoute:
      ProtectedLabarotaroyResearchVisitIdIndexRoute,
    ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute:
      ProtectedLabarotaroyResearchVisitIdLabResearchResearchIdRoute,
    ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute:
      ProtectedLabarotaroyResearchVisitIdLabResearchIndexRoute,
  }

const ProtectedLabarotaroyResearchVisitIdRouteWithChildren =
  ProtectedLabarotaroyResearchVisitIdRoute._addFileChildren(
    ProtectedLabarotaroyResearchVisitIdRouteChildren,
  )

interface ProtectedLabarotaroyResearchRouteChildren {
  ProtectedLabarotaroyResearchVisitIdRoute: typeof ProtectedLabarotaroyResearchVisitIdRouteWithChildren
  ProtectedLabarotaroyResearchIndexRoute: typeof ProtectedLabarotaroyResearchIndexRoute
}

const ProtectedLabarotaroyResearchRouteChildren: ProtectedLabarotaroyResearchRouteChildren =
  {
    ProtectedLabarotaroyResearchVisitIdRoute:
      ProtectedLabarotaroyResearchVisitIdRouteWithChildren,
    ProtectedLabarotaroyResearchIndexRoute:
      ProtectedLabarotaroyResearchIndexRoute,
  }

const ProtectedLabarotaroyResearchRouteWithChildren =
  ProtectedLabarotaroyResearchRoute._addFileChildren(
    ProtectedLabarotaroyResearchRouteChildren,
  )

interface ProtectedLaboratoryRouteChildren {
  ProtectedLaboratoryOrderIdRoute: typeof ProtectedLaboratoryOrderIdRoute
  ProtectedLaboratoryIndexRoute: typeof ProtectedLaboratoryIndexRoute
  ProtectedLaboratoryNotificationsNotificationIdRoute: typeof ProtectedLaboratoryNotificationsNotificationIdRoute
  ProtectedLaboratoryNotificationsNewRoute: typeof ProtectedLaboratoryNotificationsNewRoute
}

const ProtectedLaboratoryRouteChildren: ProtectedLaboratoryRouteChildren = {
  ProtectedLaboratoryOrderIdRoute: ProtectedLaboratoryOrderIdRoute,
  ProtectedLaboratoryIndexRoute: ProtectedLaboratoryIndexRoute,
  ProtectedLaboratoryNotificationsNotificationIdRoute:
    ProtectedLaboratoryNotificationsNotificationIdRoute,
  ProtectedLaboratoryNotificationsNewRoute:
    ProtectedLaboratoryNotificationsNewRoute,
}

const ProtectedLaboratoryRouteWithChildren =
  ProtectedLaboratoryRoute._addFileChildren(ProtectedLaboratoryRouteChildren)

interface ProtectedRecipientsRouteChildren {
  ProtectedRecipientsBloodConsumptionProtocolIdRoute: typeof ProtectedRecipientsBloodConsumptionProtocolIdRoute
  ProtectedRecipientsBloodConsumptionNewRoute: typeof ProtectedRecipientsBloodConsumptionNewRoute
  ProtectedRecipientsTransfusionsTransfusionIdRoute: typeof ProtectedRecipientsTransfusionsTransfusionIdRoute
  ProtectedRecipientsTransfusionsNewRoute: typeof ProtectedRecipientsTransfusionsNewRoute
  ProtectedRecipientsBloodConsumptionIndexRoute: typeof ProtectedRecipientsBloodConsumptionIndexRoute
  ProtectedRecipientsListIndexRoute: typeof ProtectedRecipientsListIndexRoute
  ProtectedRecipientsTransfusionsIndexRoute: typeof ProtectedRecipientsTransfusionsIndexRoute
}

const ProtectedRecipientsRouteChildren: ProtectedRecipientsRouteChildren = {
  ProtectedRecipientsBloodConsumptionProtocolIdRoute:
    ProtectedRecipientsBloodConsumptionProtocolIdRoute,
  ProtectedRecipientsBloodConsumptionNewRoute:
    ProtectedRecipientsBloodConsumptionNewRoute,
  ProtectedRecipientsTransfusionsTransfusionIdRoute:
    ProtectedRecipientsTransfusionsTransfusionIdRoute,
  ProtectedRecipientsTransfusionsNewRoute:
    ProtectedRecipientsTransfusionsNewRoute,
  ProtectedRecipientsBloodConsumptionIndexRoute:
    ProtectedRecipientsBloodConsumptionIndexRoute,
  ProtectedRecipientsListIndexRoute: ProtectedRecipientsListIndexRoute,
  ProtectedRecipientsTransfusionsIndexRoute:
    ProtectedRecipientsTransfusionsIndexRoute,
}

const ProtectedRecipientsRouteWithChildren =
  ProtectedRecipientsRoute._addFileChildren(ProtectedRecipientsRouteChildren)

interface ProtectedWarehouseRouteChildren {
  ProtectedWarehouseApplicationsRoute: typeof ProtectedWarehouseApplicationsRoute
  ProtectedWarehouseContainersRoute: typeof ProtectedWarehouseContainersRoute
  ProtectedWarehouseIssuanceRoute: typeof ProtectedWarehouseIssuanceRoute
  ProtectedWarehouseStockRoute: typeof ProtectedWarehouseStockRoute
  ProtectedWarehouseIndexRoute: typeof ProtectedWarehouseIndexRoute
}

const ProtectedWarehouseRouteChildren: ProtectedWarehouseRouteChildren = {
  ProtectedWarehouseApplicationsRoute: ProtectedWarehouseApplicationsRoute,
  ProtectedWarehouseContainersRoute: ProtectedWarehouseContainersRoute,
  ProtectedWarehouseIssuanceRoute: ProtectedWarehouseIssuanceRoute,
  ProtectedWarehouseStockRoute: ProtectedWarehouseStockRoute,
  ProtectedWarehouseIndexRoute: ProtectedWarehouseIndexRoute,
}

const ProtectedWarehouseRouteWithChildren =
  ProtectedWarehouseRoute._addFileChildren(ProtectedWarehouseRouteChildren)

interface ProtectedRouteChildren {
  ProtectedContractsRoute: typeof ProtectedContractsRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedDictionaryRoute: typeof ProtectedDictionaryRouteWithChildren
  ProtectedDonationsRoute: typeof ProtectedDonationsRoute
  ProtectedDonorsRoute: typeof ProtectedDonorsRouteWithChildren
  ProtectedExpeditionRoute: typeof ProtectedExpeditionRouteWithChildren
  ProtectedHomeRoute: typeof ProtectedHomeRoute
  ProtectedLabarotaroyResearchRoute: typeof ProtectedLabarotaroyResearchRouteWithChildren
  ProtectedLaboratoryRoute: typeof ProtectedLaboratoryRouteWithChildren
  ProtectedProcessingRoute: typeof ProtectedProcessingRoute
  ProtectedRecipientsRoute: typeof ProtectedRecipientsRouteWithChildren
  ProtectedReportsRoute: typeof ProtectedReportsRoute
  ProtectedSettingsRoute: typeof ProtectedSettingsRoute
  ProtectedSpecializedDonorsRoute: typeof ProtectedSpecializedDonorsRoute
  ProtectedWarehouseRoute: typeof ProtectedWarehouseRouteWithChildren
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedContractsRoute: ProtectedContractsRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedDictionaryRoute: ProtectedDictionaryRouteWithChildren,
  ProtectedDonationsRoute: ProtectedDonationsRoute,
  ProtectedDonorsRoute: ProtectedDonorsRouteWithChildren,
  ProtectedExpeditionRoute: ProtectedExpeditionRouteWithChildren,
  ProtectedHomeRoute: ProtectedHomeRoute,
  ProtectedLabarotaroyResearchRoute:
    ProtectedLabarotaroyResearchRouteWithChildren,
  ProtectedLaboratoryRoute: ProtectedLaboratoryRouteWithChildren,
  ProtectedProcessingRoute: ProtectedProcessingRoute,
  ProtectedRecipientsRoute: ProtectedRecipientsRouteWithChildren,
  ProtectedReportsRoute: ProtectedReportsRoute,
  ProtectedSettingsRoute: ProtectedSettingsRoute,
  ProtectedSpecializedDonorsRoute: ProtectedSpecializedDonorsRoute,
  ProtectedWarehouseRoute: ProtectedWarehouseRouteWithChildren,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface AuthRouteChildren {
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthEntryRoute: typeof AuthEntryRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,
  AuthEntryRoute: AuthEntryRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  VerifyTokenRoute: VerifyTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
